const mockUsers = {
  login: 'scudella',
  id: 18314889,
  node_id: 'MDQ6VXNlcjE4MzE0ODg5',
  avatar_url: 'https://avatars.githubusercontent.com/u/18314889?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/scudella',
  html_url: 'https://github.com/scudella',
  followers_url: 'https://api.github.com/users/scudella/followers',
  following_url: 'https://api.github.com/users/scudella/following{/other_user}',
  gists_url: 'https://api.github.com/users/scudella/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/scudella/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/scudella/subscriptions',
  organizations_url: 'https://api.github.com/users/scudella/orgs',
  repos_url: 'https://api.github.com/users/scudella/repos',
  events_url: 'https://api.github.com/users/scudella/events{/privacy}',
  received_events_url: 'https://api.github.com/users/scudella/received_events',
  type: 'User',
  site_admin: false,
  name: 'Eduardo Scudeller Libardi',
  company: null,
  blog: '',
  location: 'Campinas, S.P',
  email: null,
  hireable: null,
  bio: null,
  twitter_username: 'scudella',
  public_repos: 56,
  public_gists: 0,
  followers: 2,
  following: 8,
  created_at: '2016-04-06T19:38:16Z',
  updated_at: '2021-11-05T21:51:59Z',
};

export default mockUsers;
